export const hasIdChanged = (id?: string, queryParamId?: string) => {
  const isIdTypeOfString = typeof id === 'string';
  const isQueryParamIdTypeOfString = typeof queryParamId === 'string';

  if (isIdTypeOfString && isQueryParamIdTypeOfString) {
    return id !== queryParamId;
  }

  return false;
};
